var req = require("!!/app/node_modules/pug-loader/index.js??ref--12-1!/app/src/linagora.esn.resource/app/create/resource-create.pug");
module.exports = (req['default'] || req).apply(req, [])